module.exports = __webpack_public_path__ + "static/media/karnevalshelgen.4d51579a.png";